<template>
  <div class="dashboard">
    <img class="logo-image" src="/redstone-logo-white.svg" />
    <div v-if="loading" class="loading">Loading dashboard data...</div>
    <div v-if="error" class="error-message">{{ error }}</div>

    <div v-if="!loading && !error" class="dashboard__content">
      <!-- <TimeframeSelector
        :timeframes="timeframes"
        :selected-timeframe="selectedTimeframe"
        @update:timeframe="selectedTimeframe = $event"
      /> -->

      <KeyMetricsGrid
        :tvs-sum="tvsSum"
        :tvs-daily-change="tvsDailyChange"
        :active-providers="activeProviders"
        :daily-transactions="dailyTransactions"
        :daily-volume="dailyVolume"
        :tvs-per-client="tvsPerClient"
        :avg-response-time="avgResponseTime"
        :clients-tvl="clientsTvl"
      />

      <TvsTimelineChart
        :historical-tvs-per-client="filteredHistoricalTvsPerClient"
        :chart-theme="chartTheme"
      />

      <TvsTimelineChartClient
        :historical-data="filteredHistoricalTvsPerClient"
        :chart-theme="chartTheme"
        :color-palette="colorPalette"
      />

      <!-- <div class="charts-row">
        <ProviderPerformanceChart
          :chart-theme="chartTheme"
          :color-palette="colorPalette"
        />
        <PriceUpdatesChart
          :chart-theme="chartTheme"
          :color-palette="colorPalette"
        />
      </div> -->
      <!-- 
      <ClientDistributionSummary
        :tvs-sum="tvsSum"
        :tvs-per-client="tvsPerClient"
      /> -->

      <ClientTreemap
        :tvs-per-client="tvsPerClient"
        :chart-theme="chartTheme"
        :color-palette="colorPalette"
      />

      <!-- <TopClientsChart
        :tvs-per-client="tvsPerClient"
        :chart-theme="chartTheme"
        :color-palette="colorPalette"
      /> -->

      <ClientList
        :tvs-per-client="tvsPerClient"
        :color-palette="colorPalette"
      />
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import TimeframeSelector from "./TimeframeSelector.vue";
  import KeyMetricsGrid from "./KeyMetricsGrid.vue";
  import TvsTimelineChart from "./TvsTimelineChart.vue";
  import TvsTimelineChartClient from "./TvsTimelineChartClient.vue";
  import ProviderPerformanceChart from "./ProviderPerformanceChart.vue";
  import PriceUpdatesChart from "./PriceUpdatesChart.vue";
  import ClientDistributionSummary from "./ClientDistributionSummary.vue";
  import ClientTreemap from "./ClientTreemap.vue";
  import TopClientsChart from "./TopClientsChart.vue";
  import ClientList from "./ClientList.vue";

  // import historical from "./historical.json";

  export default {
    name: "TvsDashboard",

    components: {
      TimeframeSelector,
      KeyMetricsGrid,
      TvsTimelineChart,
      ProviderPerformanceChart,
      PriceUpdatesChart,
      ClientDistributionSummary,
      ClientTreemap,
      TvsTimelineChartClient,
      TopClientsChart,
      ClientList,
    },

    data() {
      return {
        tvsSum: 0,
        tvsPerClient: {},
        clientsDatabase: [], // ADD THIS LINE
        loading: true,
        error: null,
        timeseriesData: [],
        activeProviders: 0,
        dailyTransactions: 0,
        dailyVolume: 0,
        avgResponseTime: 0,
        tvsDailyChange: 0,
        historicalTvsPerClient: [],
        filteredHistoricalTvsPerClient: [],
        selectedTimeframe: "1M",
        timeframes: ["1M", "3M", "1Y"],
        colorPalette: [
          "#e41939",
          "#ae0822",
          "#e41a39",
          "#ff4b5c",
          "#8b1e2c",
          "#3d0309",
        ],
      };
    },

    computed: {
      filteredTimeseriesData() {
        if (!this.timeseriesData.length) return [];

        const now = Date.now();
        const timeframeMap = {
          "24H": 24 * 60 * 60 * 1000,
          "1W": 7 * 24 * 60 * 60 * 1000,
          "1M": 30 * 24 * 60 * 60 * 1000,
          "3M": 90 * 24 * 60 * 60 * 1000,
          "1Y": 365 * 24 * 60 * 60 * 1000,
          ALL: Infinity,
        };

        const timeframe = timeframeMap[this.selectedTimeframe];
        const cutoffTime = now - timeframe;

        return this.timeseriesData.filter((point) => point.x >= cutoffTime);
      },
      chartTheme() {
        return {
          mode: "dark",
          monochrome: {
            enabled: true,
            color: "#e41939",
            shadeTo: "dark",
            shadeIntensity: 0.65,
          },
        };
      },
    },

    methods: {
      formatNumber(num) {
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(num);
      },
      filterHistoricalDataWithClients(
        historicalData,
        currentClients,
        clientsDatabase
      ) {
        // Create mapping from dl-id to display name
        const dlIdToName = {};
        const nameToClient = {};

        clientsDatabase.forEach((client) => {
          if (client["dl-id"]) {
            dlIdToName[client["dl-id"]] = client.name;
            nameToClient[client.name] = client;
          }
        });
        const manualMappings = {
          sparklend: "Spark",
          euler: "Euler V2",
          "jones-dao": "Jones",
          "enzyme-finance": "Enzyme",
          "gravita-protocol": "Gravita",
          "evaa-protocol": "EVAA",
          "cian-protocol": "CIAN",
          "juice-finance": "Juice",
          "kinza-finance": "Kinza",
          "puffer-finance": "Puffer",
          sturdy: "Sturdy V2",
        };

        const result = {};
        let totalMatched = 0;
        let totalUnmatched = 0;
        Object.keys(historicalData).forEach((timestamp) => {
          result[timestamp] = {};
          let timestampMatched = 0;

          // Process each historical client for this timestamp
          Object.keys(historicalData[timestamp]).forEach(
            (historicalClientId) => {
              let matchedName = null;

              if (dlIdToName[historicalClientId]) {
                const displayName = dlIdToName[historicalClientId];
                if (currentClients[displayName]) {
                  matchedName = displayName;
                }
              }

              if (!matchedName && manualMappings[historicalClientId]) {
                const mappedName = manualMappings[historicalClientId];
                if (currentClients[mappedName]) {
                  matchedName = mappedName;
                }
              }
              if (!matchedName) {
                const normalized = this.normalizeClientName(historicalClientId);
                const currentClientKeys = Object.keys(currentClients);
                const found = currentClientKeys.find(
                  (key) => this.normalizeClientName(key) === normalized
                );
                if (found) {
                  matchedName = found;
                }
              }

              if (matchedName) {
                result[timestamp][matchedName] =
                  historicalData[timestamp][historicalClientId];
                timestampMatched++;
              } else {
                if (historicalData[timestamp][historicalClientId] > 100000000) {
                  console.log(
                    `Unmatched: ${historicalClientId} (${(historicalData[timestamp][historicalClientId] / 1e9).toFixed(2)}B)`
                  );
                  totalUnmatched++;
                }
              }
            }
          );

          totalMatched += timestampMatched;
        });


        const sampleTimestamp =
          Object.keys(result)[Object.keys(result).length - 1];
        if (result[sampleTimestamp]) {
          const sampleSum = Object.values(result[sampleTimestamp]).reduce(
            (sum, val) => sum + val,
            0
          );
        }

        return result;
      },

      normalizeClientName(name) {
        return name
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/-/g, "")
          .replace(/\./g, "")
          .replace(/protocol$/, "")
          .replace(/finance$/, "")
          .replace(/v2$/, "")
          .replace(/dao$/, "")
          .trim();
      },

      async fetchData() {
        try {
          const [
            sumResponse,
            clientsResponse,
            clientsTvl,
            historicalClient,
            clientsData,
          ] = await Promise.all([
            axios.get("https://client-tvs.a.redstone.finance/tvs-sum"),
            axios.get("https://client-tvs.a.redstone.finance/tvs-per-client"),
            axios.get("https://client-tvs.a.redstone.finance/tvl-per-client"),
            axios.get("https://client-tvs.a.redstone.finance/historical-tvs"),
            axios.get("https://client-tvs.a.redstone.finance/clients"),
          ]);

          this.clientsTvl = clientsTvl.data;
          this.tvsSum = sumResponse.data;
          this.tvsPerClient = clientsResponse.data;
          this.historicalTvsPerClient = historicalClient.data;
          this.clientsDatabase = clientsData.data;

          // Create comprehensive mapping using clients database
          this.filteredHistoricalTvsPerClient =
            this.filterHistoricalDataWithClients(
              this.historicalTvsPerClient,
              this.tvsPerClient,
              this.clientsDatabase
            );

          this.activeProviders = 15;
          this.dailyTransactions = 125000;
          this.dailyVolume = this.tvsSum * 0.15;
          this.avgResponseTime = 0.15;
          this.tvsDailyChange = 2.5;
        } catch (err) {
          this.error = "Failed to load dashboard data: " + err.message;
        } finally {
          this.loading = false;
        }
      },
    },

    mounted() {
      this.fetchData();
    },
  };
</script>

<style lang="scss" src="./TvsDashboard.scss"></style>
